import React from 'react'
import GoalLandingView from '../../../goalManagement/GoalLandingView'
import { Box } from '@mui/material'

const GoalUserSpecific = ({user}) => {
  return (
   <Box mt={0.7}>
    <GoalLandingView adminView={true} user={user} />
   </Box>
  )
}

export default GoalUserSpecific